import { useRef, useCallback } from 'react';
import { E as Escape } from './keys-BQYfE7yD.js';
import { keyboardMatches } from './match.js';

const handleKeyDown = (callbackRef) => (event) => {
    if (keyboardMatches(event, [Escape])) {
        callbackRef.current?.(event);
    }
};
const useEscapeToClose = (callback) => {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;
    const bindEscapeToCloseRef = useCallback((element) => {
        if (!element) {
            return;
        }
        element.addEventListener('keydown', handleKeyDown(callbackRef));
    }, []);
    return bindEscapeToCloseRef;
};

export { useEscapeToClose };
//# sourceMappingURL=useEscapeToClose.js.map
